import { render } from "./UpdateISO.vue?vue&type=template&id=8032bb14&scoped=true"
import script from "./UpdateISO.vue?vue&type=script&lang=js"
export * from "./UpdateISO.vue?vue&type=script&lang=js"

import "./UpdateISO.vue?vue&type=style&index=0&id=8032bb14&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8032bb14"]])

export default __exports__